import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle, Instagram, Linkedin } from "lucide-react";
import { BRAND } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <img
              src={BRAND.logo}
              alt="AF Legacy Sports"
              className="h-24 md:h-32 w-auto object-contain mb-6 -ml-2"
            />
            <p className="font-cinzel text-white text-sm tracking-[0.15em] uppercase leading-relaxed">
              We don't manage players<br />We build legacy
            </p>
          </div>

          <div>
            <div className="section-eyebrow mb-5">Navegação</div>
            <ul className="space-y-3 text-neutral-300 text-sm">
              <li><Link to="/" className="hover:text-[#A67C00] transition-colors">Início</Link></li>
              <li><Link to="/sobre-nos" className="hover:text-[#A67C00] transition-colors">Sobre nós</Link></li>
              <li><Link to="/servicos" className="hover:text-[#A67C00] transition-colors">Serviços</Link></li>
              <li><Link to="/jogadores" className="hover:text-[#A67C00] transition-colors">Jogadores</Link></li>
            </ul>
          </div>

          <div>
            <div className="section-eyebrow mb-5">Agência</div>
            <ul className="space-y-3 text-neutral-300 text-sm">
              <li><Link to="/clubes-parceiros" className="hover:text-[#A67C00] transition-colors">Clubes e parceiros</Link></li>
              <li><Link to="/submeter-perfil" className="hover:text-[#A67C00] transition-colors">Submeter perfil</Link></li>
              <li><Link to="/legacy-news" className="hover:text-[#A67C00] transition-colors">Legacy News</Link></li>
              <li><Link to="/contactos" className="hover:text-[#A67C00] transition-colors">Contactos</Link></li>
            </ul>
          </div>

          <div>
            <div className="section-eyebrow mb-5">Contactos</div>
            <ul className="space-y-4 text-neutral-300 text-sm">
              <li className="flex items-center gap-3">
                <Mail size={14} className="text-[#A67C00]" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-[#A67C00] transition-colors break-all">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={14} className="text-[#A67C00]" />
                <a href={`tel:${BRAND.scouting_phone.replace(/\s/g, "")}`} className="hover:text-[#A67C00] transition-colors">
                  {BRAND.scouting_phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={14} className="text-[#A67C00]" />
                <a href={BRAND.socials.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-[#A67C00] transition-colors">WhatsApp</a>
              </li>
              <li className="text-neutral-400 text-xs leading-relaxed pt-2 border-t border-white/5 mt-3">
                <div className="text-[#A67C00] text-[0.6rem] tracking-[0.3em] uppercase mb-2">Morada</div>
                {BRAND.address.line1}<br />
                {BRAND.address.line2}<br />
                {BRAND.address.postal}
              </li>
              <li className="flex items-center gap-3 pt-3">
                <a href={BRAND.socials.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-9 h-9 border border-white/10 hover:border-[#A67C00] hover:text-[#A67C00] text-neutral-400 flex items-center justify-center transition-colors"><Instagram size={14} /></a>
                <a href={BRAND.socials.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn" className="w-9 h-9 border border-white/10 hover:border-[#A67C00] hover:text-[#A67C00] text-neutral-400 flex items-center justify-center transition-colors"><Linkedin size={14} /></a>
                <a href={BRAND.socials.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" aria-label="WhatsApp" className="w-9 h-9 border border-white/10 hover:border-[#A67C00] hover:text-[#A67C00] text-neutral-400 flex items-center justify-center transition-colors"><MessageCircle size={14} /></a>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-divider my-12 opacity-30" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-neutral-500 text-xs tracking-widest uppercase">
            © 2026 AF Legacy Sports. Todos os direitos reservados.
          </p>
          <p className="text-neutral-600 text-xs tracking-widest uppercase">
            Scouting · Desenvolvimento · Carreira
          </p>
        </div>
      </div>
    </footer>
  );
}
